import React from 'react';

interface ScenarioResultBadgeProps {
  ok: boolean;
  labelCorrect: string;
  labelWrong: string;
}

/** GCS/동공 등 공통 정답·오답 캡슐 */
export function ScenarioResultBadge({ ok, labelCorrect, labelWrong }: ScenarioResultBadgeProps): React.ReactElement {
  const badgeStyle: React.CSSProperties = {
    display: 'inline-block',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '12px',
    lineHeight: '1',
    fontWeight: '600',
    textAlign: 'center',
    verticalAlign: 'middle',
    backgroundColor: ok ? '#dcfce7' : '#fee2e2',
    color: ok ? '#15803d' : '#991b1b'
  };

  return (
    <span style={badgeStyle}>
      {ok ? labelCorrect : labelWrong}
    </span>
  );
}
